import './App.css';
import Menu from './components/Public/Menu';
import MachineList from './components/Public/MachineList';
import Dialog from "./components/Public/Dialog";
import Login from "./components/Public/Login";
import {VendingProvider} from "./components/Public/VendingProvider";
import {Theme} from "./components/Public/Theme";
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import {Dashboard} from "./components/Private/Dashboard";
import {ProtectedRoutes} from "./components/Public/ProtectedRoutes";
import {useEffect, useState} from "react";
import Cookies from "universal-cookie";
import {useUser, UserProvider} from "./components/Private/UserProvider";
import MachinesDetails from "./components/Private/MachinesDetails";

function App() {
   const {user} = useUser();
    return (
            <BrowserRouter>
                <Theme />
                <Routes>
                    <Route path='/:idMachine' element={
                        <VendingProvider>
                            <Menu/>
                            <div className='container'>
                                <MachineList/>
                                <Dialog/>
                            </div>
                        </VendingProvider>
                    }></Route>
                    <Route path="/login" element={<Login />}></Route>
                    <Route path="/dashboard/*" element={
                        <ProtectedRoutes redirectTo="/login" isAllowed={user !== undefined}>
                            <Dashboard />
                        </ProtectedRoutes>
                    }></Route>

                </Routes>
            </BrowserRouter>


    );
}

export default App;
